import { render, staticRenderFns } from "./DsSelect.vue?vue&type=template&id=3501f4b8&scoped=true&"
import script from "./DsSelect.vue?vue&type=script&lang=js&"
export * from "./DsSelect.vue?vue&type=script&lang=js&"
import style0 from "./DsSelect.vue?vue&type=style&index=0&id=3501f4b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3501f4b8",
  null
  
)

export default component.exports